import React from 'react';
import classnames from 'classnames';
import { startOfMonth, setDate } from 'date-fns';

import Flex from '../Flex';

import { getDayOfWeek, isCurrentDayOfWeek, isWeekend } from '../shared/dates';
import {
	formatShortWeekday as defaultFormatShortWeekday,
	formatWeekday as defaultFormatWeekday,
} from '../shared/dateFormatter';

const className = 'FSHCalendarView__month-view__weekdays';
const weekdayClassName = `${className}__weekday`;

type WeekdaysProps = {
	formatShortWeekday?: typeof defaultFormatShortWeekday;
	formatWeekday?: typeof defaultFormatWeekday;
	locale: string;
	onMouseLeave?: () => void;
	style?: React.ComponentProps<'div'>['style'];
};

export default function Weekdays(props: WeekdaysProps) {
	const {
		formatShortWeekday = defaultFormatShortWeekday,
		formatWeekday = defaultFormatWeekday,
		locale,
		onMouseLeave,
		style,
	} = props;

	const anyDate = new Date();
	const beginOfMonth = startOfMonth(anyDate);
	const weekdays: React.JSX.Element[] = [];

	for (let weekday = 1; weekday <= 7; weekday += 1) {
		const weekdayDate = setDate(beginOfMonth, weekday - getDayOfWeek(beginOfMonth));
		const abbr = formatWeekday(locale ?? 'en', weekdayDate);

		weekdays.push(
			<div
				key={weekday}
				className={classnames(
					weekdayClassName,
					isCurrentDayOfWeek(weekdayDate) && `${weekdayClassName}--current`,
					isWeekend(weekdayDate, locale) && `${weekdayClassName}--weekend`
				)}
				style={style}
			>
				<abbr aria-label={abbr} title={abbr}>
					{formatShortWeekday(locale ?? 'en', weekdayDate).replace('.', '')}
				</abbr>
			</div>
		);
	}

	return (
		<Flex className={className} count={7} onFocus={onMouseLeave} onMouseOver={onMouseLeave}>
			{weekdays}
		</Flex>
	);
}
